import { makeRPCPost } from '~api/RpcAPI/RpcAPI';

import {
    IPGResponse,
    IOrderObject,
    IUpdatePayload,
    ICartItemsPayload,
    ICheckoutMessagesPayload
} from '~api/CartAPI/ICartApiSdk';

import { orderFields } from '~api/utils/orderFields';
import { skuFields } from '~api/utils/skuFields';
import { transFields } from '~api/utils/transFields';
import { parseTotals, reduceToCartItems } from '~api/CartAPI/utils/utils';
import { reduceToCartOrderData } from '~api/CartRestAPI/utils/utils';

export const fetchCartItems = async () => {
    const body = [
        {
            method: 'trans.get',
            params: [
                {
                    trans_fields: transFields,
                    order_fields: orderFields,
                    sku_fields: skuFields,
                    payment_fields: [],
                    process_offers: 1
                }
            ]
        }
    ];

    const response = await makeRPCPost<ICartItemsPayload, IPGResponse<IOrderObject>>(body);
    const cartItems = reduceToCartItems({ response });
    const cartTotals = parseTotals(response);
    const cartOrderData = reduceToCartOrderData({ response });

    return { cartItems, cartTotals, cartOrderData };
};

export const fetchCheckoutData = async () => {
    const body = [
        {
            method: 'logic.checkout--viewcart',
            params: [{ _SUBMIT: '' }]
        }
    ];

    const response = await makeRPCPost<ICheckoutMessagesPayload, IPGResponse<IOrderObject>>(body);

    return (response.data?.[0].result?.value || {}) as IOrderObject;
};

export const updateCartItem = async ({ skus, quantity, cartId, collectionId }: IUpdatePayload) => {
    const collection =
        cartId && collectionId ? { CART_ID: cartId, COLLECTION_ID: collectionId } : {};
    const body = [
        {
            method: 'rpc.form',
            params: [
                {
                    _SUBMIT: 'cart',
                    SKU_BASE_ID: skus,
                    QTY: quantity,
                    ...collection
                }
            ]
        }
    ];

    return makeRPCPost(body);
};
